'use client';
import { Configure, InstantSearch } from 'react-instantsearch';
import AnimationFadeLazy from '../animation-fade-lazy/animation-fade-lazy';
import SearchBox from '../search-box/search-box';
import SearchEmptyQueryBoundary from '../search-empty-query-boundary/search-empty-query-boundary';
import SearchHitsList from '../search-hits-list/search-hits-list';
import SearchNoResultsBoundary from '../search-no-results-boundary/search-no-results-boundary';
import SearchNoResults from '../search-no-results/search-no-results';
// LazyMotion was not loading initially visible content
import { searchClient } from '@fm-nx/algolia';
import { motion } from 'framer-motion';
import { variantsFadeInUp } from '../__constants__/animation-variants';
import SearchHitsViewed from '../search-hits-viewed/search-hits-viewed';
import SearchInsightsMiddleware from '../search-insights-middleware/search-insights-middleware';
import SearchStats from '../search-stats/search-stats';

/* eslint-disable-next-line */
export interface SearchOverlayProps {}

const index = `${process.env['NEXT_PUBLIC_ALGOLIA_INDEX_PREFIX'] || ''}everything`;

export function SearchOverlay(props: SearchOverlayProps) {
    return (
        <AnimationFadeLazy>
            <motion.div variants={variantsFadeInUp} className="mb-8 font-bold text-white h3">
                Search
            </motion.div>
            <InstantSearch
                searchClient={searchClient}
                indexName={index}
                routing={false}
                future={{ preserveSharedStateOnUnmount: true }}
                insights
            >
                <Configure clickAnalytics />
                <SearchHitsViewed />
                <SearchInsightsMiddleware />
                <div data-insights-index={index}>
                    <motion.div variants={variantsFadeInUp}>
                        <SearchBox />
                    </motion.div>
                    <SearchEmptyQueryBoundary>
                        <SearchNoResultsBoundary fallback={<SearchNoResults mode="dark" />}>
                            <AnimationFadeLazy className="my-16">
                                <SearchStats />
                            </AnimationFadeLazy>
                            <SearchHitsList />
                        </SearchNoResultsBoundary>
                    </SearchEmptyQueryBoundary>
                </div>
            </InstantSearch>
        </AnimationFadeLazy>
    );
}

export default SearchOverlay;
